import React from "react";

import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import LinkIcon from "@material-ui/icons/Link";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import Image from "@material-ui/icons/Image";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import PieChartIcon from "@material-ui/icons/PieChart";
import WalletIcon from "@material-ui/icons/AccountBalanceWallet"; // Placeholder icon, replace with actual asset icon if available

import ClientCreationView from "../../views/clients/ClientCreationView";
import ClientEditionView from "../../views/clients/ClientEditionView";
import ClientsListingView from "../../views/clients/ClientsListingView";
import ClientsMergingView from "../../views/clients/ClientsMergingView";
import ClientsNewTaskView from "../../views/clients/ClientsNewTaskView";
import ClientSpreadsheetCreationView from "../../views/clients/ClientSpreadsheetCreationView";
import ClientSpreadsheetsListingView from "../../views/clients/ClientSpreadsheetsListingView";
import ClientsReportView from "../../views/clients/ClientsReportView";
import MultipleClientEditionView from "../../views/clients/MultipleClientEditionView";
import MultipleClientMailView from "../../views/clients/MultipleClientMailView";
import MyClientCreationView from "../../views/clients/MyClientCreationView";
import MyClientEditionView from "../../views/clients/MyClientEditionView";
import MyClientsListingView from "../../views/clients/MyClientsListingView";
import MyProspectCreationView from "../../views/clients/MyProspectCreationView";
import ProspectCreationView from "../../views/clients/ProspectCreationView";
import ContractTypeCreationView from "../../views/contract-types/ContractTypeCreationView";
import ContractTypeEditionView from "../../views/contract-types/ContractTypeEditionView";
import ContractTypesListingView from "../../views/contract-types/ContractTypesListingView";
import Dashboard from "../../views/dashboard/Dashboard/index";
import MainDashboardView from "../../views/dashboard/Dashboard/MainDashboardView";
import EmployeeCreationView from "../../views/employees/EmployeeCreationView";
import EmployeeEditionView from "../../views/employees/EmployeeEditionView";
import EmployeesListingView from "../../views/employees/EmployeesListingView";
import MyProfileView from "../../views/employees/MyProfileView";
import InternEnterpriseCreationView from "../../views/intern-enterprises/InternEnterpriseCreationView";
import InternEnterpriseEditionView from "../../views/intern-enterprises/InternEnterpriseEditionView";
import InternEnterprisesListingView from "../../views/intern-enterprises/InternEnterprisesListingView";
import PartnerEnterpriseCreationView from "../../views/partner-enterprises/PartnerEnterpriseCreationView";
import PartnerEnterpriseEditionView from "../../views/partner-enterprises/PartnerEnterpriseEditionView";
import PartnerEnterprisesListingView from "../../views/partner-enterprises/PartnerEnterprisesListingView";
import AssetClassificationsListingView from "../../views/asset-classifications/AssetClassificationsListingView";
import AssetClassificationCreationView from "../../views/asset-classifications/AssetClassificationCreationView";
import AssetClassificationEditionView from "../../views/asset-classifications/AssetClassificationEditionView";
import MyTaskEditionView from "../../views/tasks/MyTaskEditionView";
import MyTasksListingView from "../../views/tasks/MyTasksListingView";
import TaskEditionView from "../../views/tasks/TaskEditionView";
import TasksListingView from "../../views/tasks/TasksListingView";
import TasksReportView from "../../views/tasks/TasksReportView";
import pagesRoutes from "./pagesRoutes";
// import InvestmentFundsListingView from '../../views/investment-funds/InvestmentFundsListingView';
// import InvestmentFundCreationView from '../../views/investment-funds/InvestmentFundCreationView';
// import InvestmentFundEditionView from '../../views/investment-funds/InvestmentFundEditionView';
import MySpreadsheetIncomesFilterView from "../../views/incomes/MySpreadsheetIncomesFilterView";
import MySpreadsheetIncomesListingView from "../../views/incomes/MySpreadsheetIncomesListingView";
import NotIdentifiedSpreadsheetIncomesListingView from "../../views/incomes/NotIdentifiedSpreadsheetIncomesListingView";
import SpreadsheetCreationView from "../../views/incomes/SpreadsheetCreationView";
import SpreadsheetIncomesChartsView from "../../views/incomes/SpreadsheetIncomesChartsView";
import SpreadsheetIncomesFilterView from "../../views/incomes/SpreadsheetIncomesFilterView";
import SpreadsheetIncomesListingView from "../../views/incomes/SpreadsheetIncomesListingView";
import SpreadsheetsListingView from "../../views/incomes/SpreadsheetsListingView";
import TriggersListingView from "../../views/trigger-types/TriggerTypeListingView";
import UserTriggersListingView from "../../views/user-triggers/UserTriggersListingView";
import UserTriggerEditionView from "../../views/user-triggers/UserTriggerEditionView";
import ReviewView from "views/employees/ReviewView";
import UsefulLinksListingView from "views/useful-links/UsefulLinksListingView";
import UsefulLinkCreationView from "views/useful-links/UsefulLinkCreationView";
import UsefulLinkEditionView from "views/useful-links/UsefulLinkEditionView";
import AssetSpreadsheetCreationView from "views/assets/AssetSpreadsheetCreationView";
import AssetSpreadsheetsListingView from "views/assets/AssetSpreadsheetsListingView";
import FiSpreadsheetCreationView from "views/fis/FiSpreadsheetCreationView";
import FiSpreadsheetsListingView from "views/fis/FiSpreadsheetsListingView";
import AssetsListingView from "views/assets/AssetsListingView";
import FiSwapSuggestionsListingView from "views/fi-swap-suggestions/FiSwapSuggestionsListingView";
import MyFiSwapSuggestionsListingView from "views/my-fi-swap-suggestions/MyFiSwapSuggestionsListingView";
import WalletBalancingsListingView from "views/wallet-balancings/WalletBalancingsListingView";
import PositionsListingView from "views/positions/PositionsListingView";
import MyPositionsListingView from "views/my-positions/MyPositionsListingView";
import WalletPositionsListingView from "views/wallet-positions/WalletPositionsListingView";
import WalletBalancingEditionView from "views/wallet-balancings/WalletBalancingEditionView";

const getDashboardRoutes = (dynamicTriggerRoutes = []) => [
  {
    hidden: true,
    path: "/dashboard",
    name: "Dashboard",
    permission: { action: "read", subject: "Dashboard" },
    icon: DashboardIcon,
    component: Dashboard,
  },
  {
    path: "/main-dashboard",
    name: "Dashboard",
    icon: DashboardRoundedIcon,
    permission: { action: "read", subject: "MainDashboard" },
    component: MainDashboardView,
  },
  {
    collapse: true,
    path: "-employees",
    name: "Assessores",
    state: "openEmployees",
    icon: AssignmentIndIcon,
    views: [
      {
        path: "/employees-listing",
        name: "Lista de assessores",
        permission: { action: "read", subject: "Employee" },
        component: EmployeesListingView,
      },
      {
        path: "/employee-creation",
        name: "Cadastrar assessor",
        permission: { action: "create", subject: "Employee" },
        component: EmployeeCreationView,
      },
      {
        hidden: true,
        path: "/employee-edition/:id",
        name: "Atualização de assessor",
        permission: { action: "update", subject: "Employee" },
        component: EmployeeEditionView,
      },
      {
        hidden: true,
        path: "/my-profile-edition",
        name: "Meus dados",
        permission: { action: "update", subject: "Myself" },
        component: MyProfileView,
      },
      {
        hidden: true,
        path: "/employee-review/:id",
        name: "Review de Assessor",
        permission: { action: "read", subject: "Employee" },
        component: ReviewView,
      },
    ],
  },
  {
    collapse: true,
    path: "-clients",
    name: "Clientes",
    state: "openClients",
    icon: PeopleOutlineIcon,
    views: [
      {
        path: "/clients-report",
        name: "Relatórios",
        permission: { action: "read", subject: "DashboardClients" },
        component: ClientsReportView,
      },
      {
        path: "/clients-listing",
        name: "Lista de clientes",
        permission: { action: "read", subject: "Client" },
        component: ClientsListingView,
      },
      {
        path: "/my-clients-listing",
        name: "Meus clientes",
        permission: { action: "read", subject: "MyClient" },
        component: MyClientsListingView,
      },
      {
        path: "/client-creation",
        name: "Cadastrar cliente",
        permission: { action: "create", subject: "Client" },
        component: ClientCreationView,
      },
      {
        path: "/my-client-creation",
        name: "Cadastrar cliente",
        permission: { action: "create", subject: "MyClient" },
        component: MyClientCreationView,
      },
      {
        path: "/prospect-creation",
        name: "Cadastrar prospect",
        permission: { action: "create", subject: "Client" },
        component: ProspectCreationView,
      },
      {
        path: "/my-prospect-creation",
        name: "Cadastrar prospect",
        permission: { action: "create", subject: "MyClient" },
        component: MyProspectCreationView,
      },
      {
        hidden: true,
        path: "/client-edition/:id",
        name: "Atualização de cliente",
        permission: { action: "update", subject: "Client" },
        component: ClientEditionView,
      },
      {
        hidden: true,
        path: "/my-client-edition/:id",
        name: "Atualização de cliente",
        permission: { action: "update", subject: "MyClient" },
        component: MyClientEditionView,
      },
      {
        path: "/client-spreadsheet-listing/:id",
        name: "Lista de planilhas",
        permission: { action: "read", subject: "ClientSpreadsheet" },
        component: ClientSpreadsheetsListingView,
      },
      {
        path: "/client-spreadsheet-creation/:id",
        name: "Importar planilha",
        permission: { action: "create", subject: "ClientSpreadsheet" },
        component: ClientSpreadsheetCreationView,
      },
      {
        hidden: true,
        path: "/clients-merging",
        name: "Merging de clientes",
        permission: { action: "update", subject: "Client" },
        component: ClientsMergingView,
      },
      {
        hidden: true,
        path: "/clients-task-creation",
        name: "Tarefas para clientes",
        permission: { action: "create", subject: "MultipleTask" },
        component: ClientsNewTaskView,
      },
      {
        hidden: true,
        path: "/multiple-client-edition",
        name: "Atualização de clientes",
        permission: { action: "update", subject: "MultipleClient" },
        component: MultipleClientEditionView,
      },
      {
        hidden: true,
        path: "/send-client-emails",
        name: "Envio de email em massa",
        permission: { action: "create", subject: "MultipleClientEmail" },
        component: MultipleClientMailView,
      },
      {
        hidden: true,
        path: "/client-wallet-balancing/:id",
        name: "Balanceamento da Carteira",
        permission: { action: "read", subject: "MyClient" },
        component: (props) => (
          <WalletBalancingsListingView {...props} tab="walletBalancings" />
        ),
      },
      {
        hidden: true,
        path: "/client-wallet-position/:id",
        name: "Posição da Carteira",
        permission: { action: "read", subject: "MyClient" },
        component: (props) => (
          <WalletBalancingsListingView {...props} tab="walletPositions" />
        ),
      },
      {
        hidden: true,
        path: "/client-wallet-balancing-edition/:id",
        name: "Atualização de Balanceamento da Carteira",
        permission: { action: "update", subject: "MyClient" },
        component: WalletBalancingEditionView,
      },
    ],
  },
  {
    collapse: true,
    path: "-tasks",
    name: "Tarefas",
    state: "openTasks",
    icon: CheckCircleOutlineIcon,
    views: [
      {
        path: "/acompanhamento-de-tarefas",
        name: "Acompanhamento de tarefas",
        permission: { action: "read", subject: "MyTask" },
        component: TasksReportView,
      },
      {
        path: "/tasks-listing",
        name: "Lista de tarefas",
        permission: { action: "read", subject: "Task" },
        component: TasksListingView,
      },
      {
        path: "/my-tasks-listing",
        name: "Minhas tarefas",
        permission: { action: "read", subject: "MyTask" },
        component: MyTasksListingView,
      },
      {
        hidden: true,
        path: "/task-edition/:id",
        name: "Atualização de tarefa",
        permission: { action: "update", subject: "Task" },
        component: TaskEditionView,
      },
      {
        hidden: true,
        path: "/my-task-edition/:id",
        name: "Atualização de tarefa",
        permission: { action: "update", subject: "MyTask" },
        component: MyTaskEditionView,
      },
    ],
  },
  {
    hidden: true,
    collapse: true,
    path: "-contract-types",
    name: "Contratos",
    state: "openContractTypes",
    icon: ListAltIcon,
    views: [
      {
        path: "/contract-types-listing",
        name: "Lista de contratos",
        permission: { action: "read", subject: "ContractType" },
        component: ContractTypesListingView,
      },
      {
        path: "/contract-type-creation",
        name: "Cadastrar contrato",
        permission: { action: "create", subject: "ContractType" },
        component: ContractTypeCreationView,
      },
      {
        hidden: true,
        path: "/contract-type-edition/:id",
        name: "Atualização de contrato",
        permission: { action: "update", subject: "ContractType" },
        component: ContractTypeEditionView,
      },
    ],
  },
  {
    collapse: true,
    path: "-intern-enterprises",
    name: "Empresas",
    state: "openInternEnterprises",
    icon: LocationCityIcon,
    views: [
      {
        path: "/intern-enterprises-listing",
        name: "Lista de empresas",
        permission: { action: "read", subject: "InternEnterprise" },
        component: InternEnterprisesListingView,
      },
      {
        path: "/intern-enterprise-creation",
        name: "Cadastrar empresa",
        permission: { action: "create", subject: "InternEnterprise" },
        component: InternEnterpriseCreationView,
      },
      {
        hidden: true,
        path: "/intern-enterprise-edition/:id",
        name: "Atualização de empresa",
        permission: { action: "update", subject: "InternEnterprise" },
        component: InternEnterpriseEditionView,
      },
    ],
  },
  {
    collapse: true,
    path: "-partner-enterprises",
    name: "Fornecedores",
    state: "openPartnerEnterprises",
    icon: LocalShippingIcon,
    views: [
      {
        path: "/partner-enterprises-listing",
        name: "Lista de fornecedores",
        permission: { action: "read", subject: "PartnerEnterprise" },
        component: PartnerEnterprisesListingView,
      },
      {
        path: "/partner-enterprise-creation",
        name: "Cadastrar fornecedor",
        permission: { action: "create", subject: "PartnerEnterprise" },
        component: PartnerEnterpriseCreationView,
      },
      {
        hidden: true,
        path: "/partner-enterprise-edition/:id",
        name: "Atualização de fornecedor",
        permission: { action: "update", subject: "PartnerEnterprise" },
        component: PartnerEnterpriseEditionView,
      },
    ],
  },
  /* {
    collapse: true,
    path: '-investment-funds',
    name: 'Fundos de investimento',
    state: 'openInvestmentFunds',
    icon: StarIcon,
    views: [
      {
        path: '/investment-funds-listing',
        name: 'Lista de fundos',
        permission: { action: 'read', subject: 'InvestmentFund' },
        mini: 'LF',
        component: InvestmentFundsListingView,
      },
      {
        path: '/investment-fund-creation',
        name: 'Cadastrar fundo',
        permission: { action: 'create', subject: 'InvestmentFund' },
        mini: 'CF',
        component: InvestmentFundCreationView,
      },
      {
        hidden: true,
        path: '/investment-fund-edition/:id',
        name: 'Atualização de fundo',
        permission: { action: 'update', subject: 'InvestmentFund' },
        mini: 'AF',
        component: InvestmentFundEditionView,
      },
    ],
  }, */
  {
    collapse: true,
    path: "-incomes",
    name: "Receitas",
    state: "openIncomes",
    icon: AttachMoneyIcon,
    views: [
      {
        path: "/spreadsheet-incomes-report",
        name: "Relatórios",
        icon: TrendingUpIcon,
        permission: { action: "read", subject: "DashboardSpreadsheetIncome" },
        component: SpreadsheetIncomesChartsView,
      },
      {
        path: "/spreadsheet-incomes-filtering",
        name: "Lista de receitas",
        permission: { action: "read", subject: "SpreadsheetIncome" },
        component: SpreadsheetIncomesFilterView,
      },
      {
        hidden: true,
        path: "/spreadsheet-incomes-listing",
        name: "Lista de receitas",
        permission: { action: "read", subject: "SpreadsheetIncome" },
        component: SpreadsheetIncomesListingView,
      },
      {
        path: "/my-spreadsheet-incomes-filtering",
        name: "Minhas receitas",
        permission: { action: "read", subject: "MySpreadsheetIncome" },
        component: MySpreadsheetIncomesFilterView,
      },
      {
        hidden: true,
        path: "/my-spreadsheet-incomes-listing",
        name: "Minhas receitas",
        permission: { action: "read", subject: "MySpreadsheetIncome" },
        component: MySpreadsheetIncomesListingView,
      },
      {
        path: "/not-identified-spreadsheet-incomes-listing",
        name: "Receitas não-identificadas",
        permission: { action: "read", subject: "SpreadsheetIncome" },
        component: NotIdentifiedSpreadsheetIncomesListingView,
      },
      {
        path: "/spreadsheets-listing",
        name: "Lista de planilhas",
        permission: { action: "read", subject: "Spreadsheet" },
        component: SpreadsheetsListingView,
      },
      {
        path: "/spreadsheet-creation",
        name: "Importar planilha",
        permission: { action: "create", subject: "Spreadsheet" },
        component: SpreadsheetCreationView,
      },
    ],
  },
  {
    collapse: true,
    path: "-trigger-types",
    name: "Notificações IA",
    state: "openTriggerTypes",
    icon: PlayArrowIcon,
    views: [
      {
        hidden: true,
        path: "/trigger-types-listing",
        name: "Lista de Triggers",
        permission: { action: "read", subject: "TriggerType" },
        component: TriggersListingView,
      },
      {
        hidden: true,
        path: "/trigger-types/:id/user-triggers",
        name: "Lista de Triggers de Clientes",
        permission: { action: "read", subject: "UserTrigger" },
        component: UserTriggersListingView,
      },
      ...dynamicTriggerRoutes,
    ],
  },
  {
    collapse: true,
    path: "-user-triggers",
    name: "Triggers de Clientes",
    state: "openUserTriggers",
    icon: PlayArrowIcon,
    views: [
      {
        hidden: true,
        path: "/user-trigger-edition/:id",
        name: "Edição de Trigger de Cliente",
        permission: { action: "update", subject: "UserTrigger" },
        component: UserTriggerEditionView,
      },
    ],
  },
  {
    collapse: true,
    path: "-assets",
    name: "Ativos",
    state: "openInvestmentProfiles",
    hidden: true,
    icon: PieChartIcon,
    views: [
      {
        path: "/assets-listing",
        name: "Lista de ativos",
        permission: { action: "read", subject: "AssetList" },
        component: AssetsListingView,
      },
      {
        path: "/asset-spreadsheet-creation/:id",
        name: "Importar planilha",
        permission: { action: "create", subject: "AssetSpreadsheet" },
        component: AssetSpreadsheetCreationView,
      },
      {
        path: "/asset-spreadsheet-listing/:id",
        name: "Lista de planilhas",
        permission: { action: "read", subject: "AssetSpreadsheet" },
        component: AssetSpreadsheetsListingView,
      },
    ],
  },
  {
    collapse: true,
    path: "-asset-classifications",
    name: "Carteiras",
    state: "openAssetClassifications",
    icon: WalletIcon,
    views: [
      {
        path: "/positions",
        name: "Posições dos clientes",
        permission: { action: "create", subject: "ClientPosition" },
        component: PositionsListingView,
      },
      {
        path: "/my-positions",
        name: "Posições dos meus clientes",
        permission: { action: "read", subject: "MyClientPosition" },
        component: MyPositionsListingView,
      },
      {
        path: "/asset-classifications-listing",
        name: "Lista de classificações",
        permission: { action: "read", subject: "AssetClassification" },
        component: AssetClassificationsListingView,
      },
      {
        path: "/asset-classification-creation",
        name: "Cadastrar classificação",
        permission: { action: "create", subject: "AssetClassification" },
        component: AssetClassificationCreationView,
        hidden: true,
      },
      {
        hidden: true,
        path: "/asset-classification-edition/:id",
        name: "Atualização de classificação",
        permission: { action: "update", subject: "AssetClassification" },
        component: AssetClassificationEditionView,
      },
    ],
  },
  {
    collapse: true,
    path: "-assets",
    name: "Fundos",
    state: "openAssets",
    icon: TrendingUpIcon,
    views: [
      {
        path: "/assets-listing",
        name: "Lista de fundos",
        permission: { action: "read", subject: "AssetList" },
        component: AssetsListingView,
      },
      {
        path: "/asset-spreadsheet-listing/:id",
        name: "Histórico de Importações",
        permission: { action: "read", subject: "AssetSpreadsheet" },
        component: AssetSpreadsheetsListingView,
      },
      {
        path: "/asset-spreadsheet-creation/:id",
        name: "Importar planilha de fundos",
        permission: { action: "create", subject: "AssetSpreadsheet" },
        component: AssetSpreadsheetCreationView,
      },
    ],
  },
  {
    collapse: true,
    path: "-fixed-incomes",
    name: "Renda Fixa",
    state: "openFixedIncomes",
    icon: TrendingUpIcon,
    views: [
      {
        path: "/fi-swap-suggestion-listing",
        name: "Opções de Troca",
        permission: { action: "read", subject: "FiSwapSuggestion" },
        component: FiSwapSuggestionsListingView,
      },
      {
        path: "/my-fi-swap-suggestion-listing",
        name: "Opções de Troca (meus clientes)",
        permission: { action: "read", subject: "MyFiSwapSuggestion" },
        component: MyFiSwapSuggestionsListingView,
      },
      {
        path: "/fi-spreadsheet-listing/:id",
        name: "Histórico de Análises",
        permission: { action: "read", subject: "FiSpreadsheet" },
        component: FiSpreadsheetsListingView,
      },
      {
        path: "/fi-spreadsheet-creation/:id",
        name: "Importar ofertas de Renda Fixa",
        permission: { action: "create", subject: "FiSwapSuggestion" },
        component: FiSpreadsheetCreationView,
      },
    ],
  },
  {
    collapse: true,
    path: "-useful-links",
    name: "Links Úteis",
    state: "openUsefulLinks",
    icon: LinkIcon,
    views: [
      {
        path: "/useful-links-listing",
        name: "Lista de links",
        permission: { action: "read", subject: "UsefulLink" },
        component: UsefulLinksListingView,
      },
      {
        path: "/useful-link-creation",
        name: "Cadastrar link",
        permission: { action: "create", subject: "UsefulLink" },
        component: UsefulLinkCreationView,
      },
      {
        hidden: true,
        path: "/useful-link-edition/:id",
        name: "Atualização de link",
        permission: { action: "update", subject: "UsefulLink" },
        component: UsefulLinkEditionView,
      },
    ],
  },
  {
    hidden: true,
    collapse: true,
    path: "-page",
    name: "Pages",
    state: "openPages",
    icon: Image,
    views: pagesRoutes,
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/dashboard",
    name: "Dashboard",
  },
];

export default getDashboardRoutes;
